<template>
  <b-form @submit.prevent>
    <b-row>
      <b-col v-for="(link, index) in link_objects" :key="`cur-${link.id}`"
             md="6"
             class="my-2">
        <b-row>
          <b-col sm="3">
            <label :v-for="link.id">{{ link.name }}</label>
          </b-col>
          <b-col sm="9">
            <input v-model="link_objects[index].url"
                   v-validate="{url: {require_protocol: true }}"
                   data-vv-scope="external-links"
                   class="form-control"
                   type="text"
                   :name="link.id"
                   :placeholder="link.template"
                   @input="emitNewLinks">
            <small class="invalid-field">
              {{ errors.first(link.id, 'external-links') }}
            </small>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-button variant="ss-standout" @click="updateLinks">
      Update
    </b-button>
  </b-form>
</template>

<script>
import {
  BForm,
  BRow,
  BCol,
} from 'bootstrap-vue';
import { waitForReady } from 'Helpers/async-computed';

export default {
  components: {
    BForm,
    BRow,
    BCol,
  },
  props: {
    feed: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    link_objects: [],
  }),
  asyncComputed: {
    link_templates: {
      async get() {
        return window.external_link_templates ?? (await axios.get(this.get_uri)).data.data;
      },
    },
  },
  computed: {
    get_uri() {
      return `/api/v1/feeds/${this.feed.uuid}/external-link-templates`;
    },
    patch_uri() {
      return `/api/v1/feeds/${this.feed.uuid}/external-links`;
    },
    links_to_submit() {
      return this.link_objects.filter(link_obj_entry => link_obj_entry.url).map((link_obj) => {
        delete link_obj.template;
        return link_obj;
      }).map(link_obj => ({
        id: link_obj.id,
        url: link_obj.url,
      }));
    },
  },
  async mounted() {
    await waitForReady(...Object.values(this.$asyncComputed)); // let asyncComputed finish
    this.link_objects = this.link_templates.map(templ_obj => ({
      ...templ_obj,
      ...(this.feed.external_links?.find(current_link_obj => templ_obj.id === current_link_obj.id) ?? {}),
    }));
  },
  methods: {
    emitNewLinks() {
      EventBus.$emit(`new-external-links`, this.links_to_submit);
      this.$emit(`input`, this.links_to_submit);
    },
    async updateLinks() {
      try {
        const res_data = (await axios.patch(this.patch_uri, {
          external_links: this.links_to_submit,
        })).data;
        if (!res_data.success) {
          toastr.error(res_data.error);
        } else {
          this.emitNewLinks(); // make sure the host form is synced
          toastr.success(`Successfully updated external links for ${this.feed.name}`);
        }
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:color";
@use "sass:map";
@use '~AssetsSass/_variables' as *;

.form-control::placeholder {
  font-style: italic;
  color: color.adjust(map.get($ss-adds, 'border-grey'), $lightness: -25%, $space: hsl);
}

.invalid-field {
  color: map.get($ss-adds, 'error');
}
</style>
